var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UX-82-Therapy-Status-Isolated",
    transform: "translate(-535.000000, -745.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(531.000000, 740.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(4.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    fill: "#5D87AF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.000000, 6.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.55766933,9.82865283 C2.73559415,14.4175824 6.49425604,18.1111111 11.1203014,18.1111111 C13.8114144,18.1111111 16.2801213,16.8799349 17.9259259,14.7309727 L16.4580461,13.2535613 L16.4358055,13.2983313 C15.2125724,15.021978 13.2331587,16.0516891 11.1203014,16.0516891 C7.65076739,16.0516891 4.78172962,13.2983313 4.6038048,9.82865283 L5.71583494,10.9479039 L7.16147413,9.49287749 L3.58073706,5.88888889 L0,9.49287749 L1.44563919,10.9479039 L2.55766933,9.82865283 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4423307,8.28245828 C19.2644058,3.69352869 15.505744,0 10.8796986,0 C8.18858561,0 5.71987869,1.23117623 4.07407407,3.38013838 L5.54195386,4.85754986 L5.56419447,4.81277981 C6.78742763,3.08913309 8.76684128,2.05942206 10.8796986,2.05942206 C14.3492326,2.05942206 17.2182704,4.81277981 17.3961952,8.28245828 L16.2841651,7.16320716 L14.8385259,8.61823362 L18.4192629,12.2222222 L22,8.61823362 L20.5543608,7.16320716 L19.4423307,8.28245828 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartial);
export default __webpack_public_path__ + "static/media/Partial.db17b20b5748f488178229f6e9984152.svg";
export { ForwardRef as ReactComponent };